module.exports = __webpack_public_path__ + "img/2.f61d0374.png";